import { delay } from 'utils';
import { DefineOwnModule } from 'stores/type';
import defer from 'lodash/defer';
import * as POPUPS from 'constants/popups';
import PopupsManager from 'managers/popups.manager';
import { State, Getters, Actions, Mutations } from './types';

const moduleState: State = {
  popupName: null,
  popupData: null,
  isOverlayActive: false,
};

const storeModule: DefineOwnModule<State, Getters, Mutations, Actions> = {
  state: moduleState,

  getters: {
    popup: (state) => state.popupName,
    isPopupActive: (_state, getters) => getters.popup !== null,
    isPopupOverlayActive: (state) => state.isOverlayActive,
    isPopupWithNameActive: (_state, getters) => (name) => getters.popup === name,
    popupData: (state) => state.popupData,
    isPopupClosable: (_state, getters) => getters.popupData === null
      || !getters.popupData.hasOwnProperty('closable')
      || getters.popupData.closable,
  },

  actions: {
    popupToggle({ dispatch, getters }, name) {
      if (getters.popup === name) {
        dispatch('popupHide', undefined);
        return;
      }

      if (getters.popup !== null) {
        dispatch('popupHide', undefined);
      }

      defer(() => dispatch('popupShow', name));
    },
    popupShow({ commit, dispatch }, name) {
      if (name === POPUPS.ENCYCLOPEDIA) {
        dispatch('encyclopediaShow');
      }

      commit('UI_POPUP_SHOW', name);
      PopupsManager.onShow(name);
    },
    popupShowWithData({ commit, dispatch }, { name, data }) {
      dispatch('popupShow', name);
      commit('UI_POPUP_DATA', data);
    },
    async popupShowNext({ dispatch }, { name, data = null }) {
      dispatch('popupHide', { hideOverlay: false });
      await delay(POPUPS.DELAY);
      if (!data) {
        dispatch('popupShow', name);
      } else {
        dispatch('popupShowWithData', { name, data });
      }
    },

    // @ts-ignore
    popupHide({ commit, getters }, { hideOverlay = true } = {}) {
      if (getters.popup === null) return;

      PopupsManager.onHide(getters.popup);
      commit('UI_POPUP_HIDE', hideOverlay);
    },
  },

  mutations: {
    UI_POPUP_SHOW(state, name) {
      state.popupName = name;
      state.isOverlayActive = true;
    },
    UI_POPUP_DATA(state, data) {
      state.popupData = data;
    },
    UI_POPUP_HIDE(state, hideOverlay) {
      state.popupName = null;
      if (hideOverlay) {
        state.isOverlayActive = false;
        state.popupData = null;
      }
    },
  },
};

export default storeModule;
